export default __webpack_public_path__ + "static/media/hidden.62e41ab2.gif";